import React, { useRef } from "react";
import logo from "./logo.png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Show whatever unit is stored for the item (kg, gram, liter, packets, ...).
const unitLabel = (u) => (u ? String(u) : "");

function Invoice2({ data }) {
  const pdfRef = useRef();

const handleDownload = () => {
  const input = pdfRef.current;

  // Step 1: Remove modal scroll limits
  const modalDialog = document.querySelector(".modal-dialog");
  const modalBody = document.querySelector(".modal-body");

  const originalClass = modalDialog.className;
  const originalOverflow = modalBody.style.overflow;
  const originalHeight = input.style.height;

  modalDialog.classList.remove("modal-dialog-scrollable");
  modalBody.style.overflow = "visible";
  input.style.height = "auto";

  // Step 2: Render full-size canvas
  html2canvas(input, {
    scale: 2,
    useCORS: true,
    scrollY: 0,
    windowWidth: input.scrollWidth,
    windowHeight: input.scrollHeight,
  }).then((canvas) => {
    const imgData = canvas.toDataURL("image/png");

    // Step 3: Convert px to mm
    const pxToMm = 0.264583; // 1px = 0.264583 mm
    const imgWidthMm = canvas.width * pxToMm;
    const imgHeightMm = canvas.height * pxToMm;

    // Step 4: Create PDF with custom dimensions
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [imgWidthMm, imgHeightMm],
    });

    pdf.addImage(imgData, "PNG", 0, 0, imgWidthMm, imgHeightMm);
    pdf.save("purchase-order.pdf");

    // Step 5: Restore original modal styles
    modalDialog.className = originalClass;
    modalBody.style.overflow = originalOverflow;
    input.style.height = originalHeight;
  });
};





  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        background: "#f9f9f9",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: "10px" }}>
        <button onClick={handleDownload} className="btn btn-primary">
          Download PDF
        </button>
      </div>

<div
  ref={pdfRef}
  style={{
    background: "#fff",
    padding: "10px",
    minWidth: "1200px",
    width: "fit-content",
    height: "auto",
    boxSizing: "border-box",
  }}
>


        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            paddingBottom: "10px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <div style={{ width: "150px" }}>
            <img src={logo} alt="Logo" style={{ width: "100%" }} />
          </div>
          <div style={{ flex: 1, textAlign: "center", minWidth: "250px" }}>
            <h2 style={{ margin: "5px 0", fontSize: "20px" }}>PURCHASE ORDER</h2>
            <h1 style={{ margin: "5px 0", fontSize: "24px" }}>
              Ekta Foundation
            </h1>
            <p style={{ margin: 0, fontSize: "14px", lineHeight: "1.5" }}>
              Block-B, Plot No, Kiran Garden, adj. Matiyala,
              <br />
              Gulab Bhag, Block A, Police Chowki,
              <br />
              Uttam Nagar, Delhi, 110059
            </p>
          </div>
        </div>

        {/* Item Table */}
        <div style={{ overflowX: "auto", marginTop: "20px" }}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={headerCell}>Purchase ID</th>
                <th style={headerCell}>Item Name</th>
                <th style={headerCell}>Kitchen Name</th>
                <th style={headerCell}>Vendor Name</th>
                <th style={headerCell}>Required Quantity</th>
                <th style={headerCell}>Required Date</th>
                <th style={headerCell}>Approved Quantity</th>
                <th style={headerCell}>Receive Quantity</th>
                <th style={headerCell}>Pending Quantity</th>
              </tr>
            </thead>
            <tbody>
              {data.data.map((item, index) => (
                <tr key={index}>
                  <td style={tdStyle}>{item.purchase_id}</td>
                  <td style={tdStyle}>{item.stock_name}</td>
                  <td style={tdStyle}>{item.kitchen_name}</td>
                  <td style={tdStyle}>{item.vendor_name}</td>
                  <td style={tdStyle}>
                    {item.request_quantity
                      ? `${item.request_quantity} ${unitLabel(item.unit)}`.trim()
                      : "-"}
                  </td>
                  <td style={tdStyle}>
                    {new Date(item.recieve_date).toLocaleDateString()}
                  </td>
                  <td style={tdStyle}>
                    {item.approvequantity
                      ? `${item.approvequantity} ${unitLabel(item.unit)}`.trim()
                      : "-"}
                  </td>
                  <td style={tdStyle}>
                    {item.recievequantity
                      ? `${item.recievequantity} ${unitLabel(item.unit)}`.trim()
                      : "-"}
                  </td>
                  <td style={tdStyle}>
                    {item.pendingquantity
                      ? `${item.pendingquantity} ${unitLabel(item.unit)}`.trim()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

// Styles
const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: "10px",
  fontSize: "12px",
};

const headerCell = {
  border: "1px solid #ccc",
  padding: "8px",
  background: "#eaeaea",
  textAlign: "center",
};

const tdStyle = {
  border: "1px solid #ccc",
  padding: "8px",
  textAlign: "center",
};

export default Invoice2;
